import { AGeneralActionCreator } from '../classes/general-action-creator.abstract';

export const CORE_ACTIONS = {
  'SET_LOADER': 'CORE.SET_LOADER',
  'TOGGLE_ERROR_MODAL': '[CORE] TOGGLE ERROR MODAL',
  'TOGGLE_UPGRADE_INJECTOR': '[CORE] TOGGLE UPGRADE INJECTOR',
  'CAST_ACTION': 'CORE.CAST_ACTION',
  'CLEAR_ALL_CACHED_ITEMS': 'CORE.CLEAR_ALL_CACHED_ITEMS',
  'SET_IS_EMBEDDED': 'SET_IS_EMBEDDED',
  'SET_ENVIRONMENT_DETAILS': 'SET_ENVIRONMENT_DETAILS',
  "SKIP_USER_INTERACTION_UPDATE": 'SKIP_USER_INTERACTION_UPDATE'
};

export class ToggleErrorModalAction extends AGeneralActionCreator {
  readonly type: any = CORE_ACTIONS.TOGGLE_ERROR_MODAL;

  constructor(payload: { status: boolean} & any) {
    super(payload);
  }
}

export class ToggleUpgradeInjectorStatusAction extends AGeneralActionCreator<boolean> {
  readonly type: any = CORE_ACTIONS.TOGGLE_UPGRADE_INJECTOR;

  constructor(status: boolean) {
    super(status);
  }
}
